import { Directive, HostBinding, Input } from '@angular/core';
import { UntypedFormControl, FormGroupDirective, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[comFormLabelName]',
})
export class FormLabelNameDirective {
  @Input('comFormLabelName') fieldName: string;

  private cachedFieldObject: UntypedFormControl;

  constructor(private parentForm: FormGroupDirective) {}

  @HostBinding('class.invalid') get invalid() { return this.fieldObject?.invalid && this.fieldObject?.touched; }
  @HostBinding('class.required') get required() {
    if (this.fieldObject?.validator === null) {
      return false;
    }
    const validators = this.fieldObject?.validator({} as AbstractControl);
    return validators && validators.required;
  }
  @HostBinding('attr.for') get linkedForm() { return this.fieldName; }

  private get fieldObject(): UntypedFormControl {
    if (this.cachedFieldObject) {
      return this.cachedFieldObject;
    }
    this.cachedFieldObject = this.parentForm.directives.find((directive) => directive.name === this.fieldName)?.control;
    return this.cachedFieldObject;
  }

}
